import { useAuthContext } from "@auth/context/Auth.context";
import { Button } from "@components/index";
import styles from "./Login.module.scss";

export default function Login() {
  const { login } = useAuthContext();

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <img
          src="https://auth.ambevdevs.com.br/resources/4efsd/login/ambevtech-dark/img/abinbev.svg"
          alt="ABInBev"
          className={styles.logo}
        />

        <div className={styles.labels}>
          <h2>Fazer login</h2>
          <p>
            Escolha seu acesso. Caso não possua, solicite ao responsável pela
            integração com a Ambev.
          </p>
        </div>

        <div className={styles.form}>
          <Button
            label="Sou Ambev"
            size="lg"
            blockedWidth
            onClick={() => login("Ambev")}
          />
          <Button
            label="Sou Terceiro"
            size="lg"
            buttonStyle="secondary"
            blockedWidth
            onClick={() => login("Third")}
          />
        </div>
      </div>
    </div>
  );
}
